export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "HomebaseMasterImportWorker.7c8c028174bb24c305e0.worker.js");
}
